<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    <div v-if="documents">
                        <v-row>
                        <v-btn @click="$router.go(-1)" outlined style="border: none;margin-right: 10px" title="Retourner à la liste des marchands"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>

                        {{$t('documents.document_management')}} DE :
                        <div >
                            <div >
                                {{documents._marchand_id._email}}
                            </div>
                        </div>
                            </v-row>
                    </div>
                    <div v-else>
                        <v-row>
                        <v-btn @click="$router.go(-1)" outlined style="border: none;margin-right: 10px" title="Retourner à la liste des marchands"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>

                        {{$t('documents.document_management')}}
                         </v-row>
                    </div>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-row class="" style="margin-top: 3%">
                    <v-container>
                        <div v-if="documents" >
                            <div>
                                <v-row>
                                    <v-col >
                                        <v-btn v-if="documents._valide===false" style="margin-right: 10px" @click="valideItem(documents)" :value="(documents._valide)?'true':''"  class="float-right" color="primary" >{{$t('documents.valider')}}</v-btn>
                                        <div  v-if="documents._valide===true ">
                                            <v-alert v-if="documents.user_valid._first_name && documents.user_valid._last_name"  style="padding: 15px;margin: 10px"   dense outlined :type="(errors.update_error)?'error':'success'"> {{$t('documents.valide_date')}} {{ new Date(documents._valide_date).toLocaleDateString()}} par {{ documents.user_valid._first_name}} {{ documents.user_valid._last_name}}</v-alert>
                                            <v-alert v-else  style="padding: 15px;margin: 10px"   dense outlined :type="(errors.update_error)?'error':'success'"> {{$t('documents.valide_date')}} {{ new Date(documents._valide_date).toLocaleDateString()}} par {{ documents.user_valid._email}}</v-alert>

                                        </div>

                                    </v-col>
                                </v-row>
                                <div class="row">
                                    <div class="col-6">
                                        <v-col cols="12" >
                                            <label style="font-weight: 600;color: #29B3A6">{{$t('documents.num_card')}}</label><br>

                                            <div v-if="documents._numCard">
                                                <v-text-field
                                                        :value="documents._numCard"
                                                        :label="$t('documents.num_card')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>

                                            <div v-else>
                                                <v-text-field
                                                        value="Null"
                                                        :label="$t('documents.file')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>
                                        </v-col>

                                    </div>

                                    <div class="col-6">
                                        <v-col cols="12" >
                                            <label style="font-weight: 600;color: #29B3A6">{{$t('documents.file')}}</label><br>

                                            <div v-if="documents._fileCard">
                                                <a :href="base+documents._fileCard" target="_blank">
                                                    <v-text-field
                                                            :value="documents._fileCard.substr(24)"
                                                            :label="$t('documents.file')"
                                                            solo
                                                            disabled
                                                    ></v-text-field>
                                                </a>
                                            </div>
                                            <div v-else>
                                                <v-text-field
                                                        value="Null"
                                                        :label="$t('documents.file')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>

                                        </v-col>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <v-col cols="12" >
                                            <label style="font-weight: 600;color: #29B3A6">{{$t('documents.num_rccm')}}</label><br>

                                            <div v-if="documents._numRCCM">
                                                <v-text-field
                                                        :value="documents._numRCCM"
                                                        :label="$t('documents.num_rccm')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>

                                            <div v-else>
                                                <v-text-field
                                                        value="Null"
                                                        :label="$t('documents.file')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>
                                        </v-col>

                                    </div>
                                    <div class="col-6">
                                        <v-col cols="12" >
                                            <label style="font-weight: 600;color: #29B3A6">{{$t('documents.file_rccm')}}</label><br>
                                            <div v-if="documents._fileRCCM">
                                                <a :href="base+documents._fileRCCM" target="_blank">

                                                    <v-text-field
                                                            :value="documents._fileRCCM.substr(24)"
                                                            :label="$t('documents.num_rccm')"
                                                            solo
                                                            disabled
                                                    ></v-text-field>
                                                </a>
                                            </div>
                                            <div v-else>
                                                <v-text-field
                                                        value="Null"
                                                        :label="$t('documents.num_rccm')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>


                                        </v-col>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <v-col cols="12" >
                                            <label style="font-weight: 600;color: #29B3A6">{{$t('documents.num_ifu')}}</label><br>

                                            <div v-if="documents._numIFU">
                                                <v-text-field
                                                        :value="documents._numIFU"
                                                        :label="$t('documents.num_ifu')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>

                                            <div v-else>
                                                <v-text-field
                                                        value="Null"
                                                        :label="$t('documents.file')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>
                                        </v-col>


                                    </div>
                                    <div class="col-6">
                                        <v-col cols="12" >
                                            <label style="font-weight: 600;color: #29B3A6">Fichier IFU</label><br>
                                            <div v-if="documents._fileIFU">
                                                <a :href="base+documents._fileIFU" target="_blank">

                                                    <v-text-field
                                                            :value="documents._fileIFU.substr(24)"
                                                            :label="$t('documents.file')"
                                                            solo
                                                            disabled
                                                    ></v-text-field>
                                                </a>
                                            </div>
                                            <div v-else>
                                                <v-text-field
                                                        value="Null"
                                                        :label="$t('documents.file')"
                                                        solo
                                                        disabled
                                                ></v-text-field>
                                            </div>


                                        </v-col>

                                    </div>
                                </div>

                            </div>
                        </div>
                            <div v-else>
                                <v-row  class="text-center" style="margin-top: 3%">
                               <span style="margin-left: 40%;font-size: 20px;font-weight: 600;color: #29B3A6">{{$t('documents.not_document')}}</span>
                                </v-row>
                            </div>
                        </v-container>
                </v-row>
            </v-card>
        </div>
    </div>
</template>


<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    export default {
        name: "Documents",
        data () {
            return {
                picker: new Date().toISOString().substr(0, 10),
                type:  { state: 'CNI', abbr: 'CNI' },
                items: [
                    { state: 'CNI', abbr: 'CNI' },
                    { state: 'Passeport', abbr: 'Passeport' },
                ],
                submitting:false,
                valid:true,
                lazy:false,
                dialog: false,
                base: process.env.FILE_BASE_URL_DOC,
                notifications: false,
                sound: true,
                widgets: false,
                errors:{},
                search: '',
                id:undefined,
                date_issue: null,
                date_expired:null,
                menu: false,
                menus: false,
                headers: [
                    {text: this.$t('documents.user'), value: '_user_id',
                        align: 'start',
                        sortable: false,
                    },
                    {text: this.$t('documents.num_card'), value: '_numCard'},
                    {text: this.$t('documents.file_card'), value: '_fileCard'},
                    {
                        text: this.$t('documents.num_rccm'),
                        align: 'start',
                        sortable: false,
                        value: '_numRCCM',
                    },
                    {text: this.$t('documents.file_rccm'), value: '_fileRCCM'},
                    {text: this.$t('documents.num_ifu'), value: '_numIFU'},
                    {text: this.$t('documents.file_ifu'), value: '_fileIFU'},
                    { text: this.$t('documents.valider'), value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {
                    _num: '',
                    _type: '',
                    _file: '',
                    _date_issue: '',
                    _date_expired: '',
                    _place_establishment: '',
                    _code: '',
                    _valide: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _type: '',
                    _num: '',
                    _file: '',
                    _date_issue: '',
                    _date_expired: '',
                    _place_establishment: '',
                    _code: '',
                    _valide: '',
                    _created_at: 0,
                    _id:''
                },

            }
        },
        computed: {
            ...mapState('documents/',['documents']),
            formTitle () {
                return this.editedIndex === -1 ? this.$t('Nouveau document') : this.$t('Modifier document')
            },
        },
        mounted(){
            this.$store.dispatch('documents/getDocument',this.$route.params.id).then(response=>{
               console.log('documents',response)
            });

        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            menu (val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
        },
        methods: {
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ]
            },
            editItem (item) {
                this.editedIndex = this.documents.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true;
                this.id = item._id;
            },

            valideItem (item) {
                let message = (item._valide)?this.$t('documents.invalid_document'):this.$t('documents.valid_document');
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t(message),
                    confirmButtonText:this.$t('marchand.activate'),
                    cancelButtonText: this.$t('marchand.deactivate'),
                    showCancelButton: true,
                    confirmButtonColor:'#29B3A6'

                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('documents/validDocument', this.documents._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            saves (date) {
                this.$refs.menu.save(date)
            },
            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },

            save () {
                let VueBox = this;
                let data = new FormData();
                data.append("user_id",this.$store.getters.auth._id);
                data.append("type",this.editedItem._type);
                data.append("num",this.editedItem._num);
                data.append("place_establishment",this.editedItem._place_establishment);
                data.append("date_issue",this.editedItem._date_issue);
                data.append("date_expired",this.editedItem._date_expired);
                data.append("file",this.editedItem._file);
                if (this.id)
                    data.append("id",this.id);
                this.$store.dispatch('documents/setDocument',data).then((response)=>{
                    console.log('set document',response)
                    if (response.error){
                        this.errors.operation=response.message;
                    }else{
                        VueBox.$parent.resetDatas(VueBox);
                        this.close();
                        VueBox.toast('success',this.$t(response.message));

                    }
                })
            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>

<style scoped>

</style>
